module.exports = __webpack_public_path__ + "static/media/img_9__2.9b41ffc0.jpg";